import { API } from "aws-amplify";

// Every call to the officeDuties service lives here so the components stay
// declarative and the endpoint shape is documented in one place.

const ENDPOINT = "officeDuties";

export const getRosters = () => API.get(ENDPOINT, "/officeDuties/rosters");

export const saveRoster = (body) =>
  API.post(ENDPOINT, "/officeDuties/rosters", { body });

export const getWeeks = ({ rosterId, from, to }) =>
  API.get(ENDPOINT, "/officeDuties/weeks", {
    queryStringParameters: { rosterId, ...(from ? { from } : {}), ...(to ? { to } : {}) },
  });

export const generateWeeks = ({ rosterId, weeks, from, dryRun, notify }) =>
  API.post(ENDPOINT, "/officeDuties/generate", {
    body: { rosterId, weeks, from, dryRun, notify },
  });

export const updateWeek = (body) =>
  API.put(ENDPOINT, "/officeDuties/weeks", { body });

export const importHistory = (body) =>
  API.post(ENDPOINT, "/officeDuties/history", { body });

export const adjustHistory = (body) =>
  API.put(ENDPOINT, "/officeDuties/history", { body });

export const getCurrentDuty = ({ employeeId, upcoming } = {}) =>
  API.get(ENDPOINT, "/officeDuties/current", {
    queryStringParameters: {
      ...(employeeId ? { employeeId } : {}),
      ...(upcoming ? { upcoming } : {}),
    },
  });
